import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Injectable({
    "providedIn": "root"
  })
@Pipe({
    "name": "recordablepriority",
    standalone: true
})
export class RecordablePriorityNamePipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
        case 1:
            return "Urgent";
        case 2:
            return "High";
        case 3:
            return "Medium";
        case 4:
            return "Low";
        default:
            return "";
        }
    }
}
